function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { warning40 } from "@churchofjesuschrist/eden-style-constants";
import { AlertWarningFilled } from "@churchofjesuschrist/eden-icons";
import Banner from "./Banner";

const Warn = props => /*#__PURE__*/React.createElement(Banner, _extends({
  color: warning40,
  Icon: AlertWarningFilled
}, props));

Warn.propTypes = {
  /** Title part of the message text */
  title: PropTypes.string,

  /** Description part of the message text */
  description: PropTypes.string.isRequired,

  /** Task button element(s) (should be "small") */
  action: PropTypes.element,

  /** Callback function to execute when user dismisses the banner */
  onClose: PropTypes.func
};
export default Warn;